import {load} from '@shopify/theme-sections'
import '../../styles/templates/blog.scss'
import '../sections/index-hero-slider'
import '../sections/section-blog-navigation'

load([
    `index-hero-slider`,
    `section-blog-navigation`
])
